import { GetStaticProps } from "next"
import { BlogListItem } from "../../modules/blog/BlogListItem"
import { MojeHeader } from "../../components/header/MojeHeader"
import { MojeFooter } from "../../components/MojeFooter"

export default function BlogIndex(props) {
  return (
    <>
      <MojeHeader venueMode showSearch scrollable />
      <div
        className="container m-auto max-w-screen-lg"
        style={{ paddingTop: 100 }}
      >
        <div className="my-2"></div>

        {props.articles &&
          props.articles.map((art: any) => (
            <BlogListItem
              title={art.title}
              link={art.slug ?? art.id}
              summary={art.summary}
              publishedAt={art.publishedAt}
              // subtitle="Rola świętowania z rodziną i rówieśnikami w rozwoju społecznym i psychologicznym"
              imgUrl={
                art.media && art.media.length > 0 ? art.media[0].url : undefined
              }
            />
          ))}
        {/* <BlogListItem
          title="Dlaczego świętujemy Urodziny?"
          link="dlaczego-swietujemy-urodziny"
          summary="Z perspektywy dziecka urodziny są wyjątkowym świętem, na które czeka się przez cały rok. Dzień urodzin jest po prostu jego dniem – dniem na wyłączność. Cała uwaga skupiona jest na nim, przez co czuje się szczególnie wyróżnione i kochane. To również bardzo ważny dzień dla rodziców, którzy dokładają wszelkich starań, aby celebrowanie urodzin swojej pociechy było dla niej niezapomnianym przeżyciem."
          // subtitle="Rola świętowania z rodziną i rówieśnikami w rozwoju społecznym i psychologicznym"
          imgUrl="https://res.cloudinary.com/mojeurodziny/image/upload/c_scale,w_600,q_100/v1616586252/blog/AdobeStock_249507727_stools.webp"
          publishedAt={parse("2021-08-01", "yyyy-MM-dd", new Date())}
        />
        <BlogListItem
          title="Tata w akcji. Poradnik o organizacji urodzin dla ojców."
          link="tata-w-akcji-poradnik-o-organizacji-urodzin-dla-ojcow"
          summary="A więc, drogi tato, organizujesz urodziny dla dziecka? Nie mogło
          się lepiej złożyć! Jesteśmy przekonani, że będziesz się przy tym
          doskonale bawić. A żeby ułatwić Ci zadanie, prosimy, przyjmij od
          nas kilka rad dla początkującego… event managera!"
          // subtitle="Tata w akcji. Poradnik o organizacji urodzin dla ojców."
          imgUrl="https://res.cloudinary.com/mojeurodziny/image/upload/c_scale,q_100,w_1600/v1616586252/blog/AdobeStock_258535593_yietip.webp"
          publishedAt={parse("2021-07-01", "yyyy-MM-dd", new Date())}
        />
        <BlogListItem
          title="Urodziny dawniej i dziś – czego oczekują współczesne dzieci?"
          link="urodziny-dawniej-i-dzis-czego-oczekuja-wspolczesne-dzieci"
          summary="  Dzisiejsze mamy zapewne doskonale pamiętają ekscytację, która jako
          dzieciom towarzyszyła im w dniu ich przyjęcia urodzinowego.
          Ówczesne przyjęcia, organizowane z reguły w domu, przygotowywane
          były przez mamy, które stawały na głowie, żeby na półmiskach
          wyczarować prawdziwe kolorowe cuda. Wśród urodzinowych „gier
          salonowych” królował twister, eurobiznes i inne planszówki, czasem
          odpalano gry komputerowe. Bez względu na to, jak cudowne i
          niezapomniane były to spotkania, nie ulega wątpliwości, że
          repertuar atrakcji urodzinowych był mocno ograniczony."
          // subtitle="Urodziny dawniej i dziś – czego oczekują współczesne dzieci?"
          imgUrl="https://res.cloudinary.com/mojeurodziny/image/upload/c_scale,q_100,w_600/v1616586252/blog/AdobeStock_320581544_iluxzw.webp"
          publishedAt={parse("2021-06-01", "yyyy-MM-dd", new Date())}
        /> */}
      </div>
      <MojeFooter />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const res = await fetch(
    process.env.NEXT_PUBLIC_API_URL + "/v1/public/articles"
  )
  const articles = await res.json()

  return {
    props: {
      articles: articles ?? [],
    },
    revalidate: 300,
  }
}
